import { Container } from './styles'

export function SummaryRoot({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
